import { useEffect, useRef, useState } from 'react'
import { get } from 'lodash'

/**
 * @typedef {Object} ResolveComponentDataHook
 * @property {React.MutableRefObject<any>} jsElementRef
 * @property {Object<string, any>} jsComponentData
 */

/**
 * @typedef {Object} ResolveComponentDataProps
 * @property {string} containerType
 * @property {string[]} attributeNames
 * @property {Object<string, any>=} defaultValues
 */

/**
 * Resolve Drupal JS component data.
 * @param {ResolveComponentDataProps} props
 * @return {ResolveComponentDataHook}
 */
const useResolveComponentData = ({ containerType, attributeNames, defaultValues = {} }) => {
  const jsElementRef = useRef()
  const [jsComponentData, setJsComponentData] = useState(defaultValues)

  useEffect(() => {
    if (jsElementRef && jsElementRef.current) {
      /**
       * @type {HTMLElement}
       */
      const element = jsElementRef.current
      const containerSelector = `[data-container-type="${containerType}"]`
      const jsComponentContainer = element.closest(containerSelector)
      if (jsComponentContainer) {
        /**
         * @type {Object<string, any>}
         */
        const dataAttributes = {}
        attributeNames.forEach((attributeName) => {
          const value =
            jsComponentContainer.getAttribute(attributeName) ||
            get(defaultValues, attributeName, '')
          dataAttributes[attributeName] = value
        })
        setJsComponentData(dataAttributes)
      }
    }
  }, [jsElementRef])

  return {
    jsElementRef,
    jsComponentData,
  }
}

export default useResolveComponentData
